import React from "react";
import { HashLink as Link } from "react-router-hash-link";

const Formation = () => {
  return (
    <section className="formation-section" id="formations">
      <div className="formation-container">
        {/* Colonne gauche */}
        <div className="formation-intro">
          <h2 className="formation-title">
            NOS <br />
            FORMATIONS
          </h2>
          <p className="formation-subtitle">
            APPRENDRE, OUI. S’ENNUYER, JAMAIS.
          </p>
          <p className="formation-text">
            Chez UP4MIND, on forme des gens cool sur des sujets sérieux. Nos
            formations, c’est du contenu concret, à jour, et taillé pour les
            pros d’aujourd’hui (et même ceux de demain).
          </p>
          <Link to="/contact" className="formation-btn">
            Contactez-nous !
          </Link>
        </div>

        {/* Colonne droite avec 3 colonnes internes */}
        <div className="formation-blocks">
          <div className="formation-card yellow">
            <h3>NOS DOMAINES DE PRÉDILECTION :</h3>
            <ul>
              <li>- Compétences digitales & communication</li>
              <li>- Communication Informatique, cybersécurité</li>
              <li>- Langues professionnelles </li>
              <li>
                - Formations réglementaires & certifiantes (HACCP, Santé &
                sécurité au travail, bureautique…)
              </li>
            </ul>
          </div>
          <div className="formation-card blue">
            <h3>COMPÉTENCES TRANSVERSALES :</h3>
            <ul>
              <li>
                - Soft skills, organisation, prise de parole, gestion du temps,
                gestion de projet
              </li>
              <li>
                - Outils bureautiques et collaboratifs (Google Workspace,
                Microsoft Office)
              </li>
            </ul>
          </div>
          <div className="formation-card pink">
            <h3>MODALITÉS :</h3>
            <ul>
              {/* <li>- Finançables CPF / OPCO </li> */}
              <li>- En présentiel, à distance ou en format hybride</li>
              <li> - Programmes adaptés à chaque public</li>
            </ul>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Formation;
